import { ERROR_IMAGE_IS_CORRUPTED } from "constants/image";

export type Result = {
  success: boolean;
  error?: string;
  result?: string | ArrayBuffer | null;
};

export const readImageContent = (
  reader: FileReader,
  file: File,
): Promise<Result> => {
  return new Promise(resolve => {
    reader.onload = (e: ProgressEvent<FileReader>) => {
      const img = new Image();
      img.onload = () => {
        resolve({ success: true, result: reader.result });
      };
      img.onerror = () => {
        resolve({
          success: false,
          error: ERROR_IMAGE_IS_CORRUPTED,
          result: reader.result,
        });
      };
      img.src = e.target?.result;
    };
    reader.readAsDataURL(file);
  });
};
